import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ShowList from '../../containers/ShowsList/ShowsList';
import { LANDING as landingTitle } from '../../constants/titles';
// import * as actions from '../../store/actions/index';
import { fetchShows } from '../../store/actions';
import { saveMovieReminderSubscription } from '../../store/actions';
import ResponsiveWrapper from '../../components/UI/ResponsiveWrapper/ResponsiveWrapper';
import { Carousel, Col, Image, Row } from 'react-bootstrap';
import Kinostyles from '../../components/Util/AutokinoStylesComponent.module.css';
import * as ROUTES from '../../constants/routes';
import image1 from '../../assets/images/autokino/kinoprogramm/Lounge.jpg';
import iconSieger from '../../assets/images/autokino/kinoprogramm/_Sieger.png';
import iconPrivat from '../../assets/images/autokino/kinoprogramm/_Privacy.png';
import iconVierbeiner from '../../assets/images/autokino/kinoprogramm/_Vierbeiner.png';
import iconSnacks from '../../assets/images/autokino/kinoprogramm/_Liefern.png';
import imageZeitleiste from '../../assets/images/autokino/kinoprogramm/Schritte_Zeitleiste.svg';
import imageSterne from '../../assets/images/autokino/kinoprogramm/Sterne.svg';
import imageRezBackground from '../../assets/images/autokino/kinoprogramm/Rezensionen_Rahmen.svg';
import image3 from '../../assets/images/autokino/kinoprogramm/test_cockails_zum_kinoprogramm_wien_im_autokino.jpg';
import image4 from '../../assets/images/autokino/kinoprogramm/test_kino_parkplatz_besucher_kinofilm_start.jpg';
import image2 from '../../assets/images/autokino/kinoprogramm/test_kinosnacks_fuer kinoprogramm_geliefert_zum_auto.jpg';
import FilmprogrammSignup from '../../components/FilmprogrammSignup/FilmprogrammSignup';
import NewsletterSignup from '../../components/NewsletterSignup/NewsletterSignup';
import ScriptTag from 'react-script-tag/lib/ScriptTag';
import { animateScroll as scroll, scroller } from 'react-scroll';
import { useRef } from 'react';
const LandingPage = props => {
  useEffect(() => {
    async function fetchShows() {
      console.log('call fetch categorties');
      await props.fetchShows(null);
    }

    fetchShows();

    const query = new URLSearchParams(window.location.search);
    const opensubscriptionpopup = query.get('openfpsub');
    const selectshow = query.get('selectshow');
    if (opensubscriptionpopup === 'true') {
      setTimeout(function() {
        if (typeof window.mjOpenPopin === 'function') {
          document.getElementById('filmprogrammNewsletterButton').click();
        } else {
          setTimeout(function() {
            document.getElementById('filmprogrammNewsletterButton').click();
          }, 4000);
        }
      }, 2000);
    }
    if (selectshow !== null && selectshow !== '') {
      setTimeout(function() {
        scrollTo(selectshow);
      }, 2000);
    }
  }, []);
  function scrollTo(anchor) {
    scroller.scrollTo(anchor, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
  }
  //console.log('render cat = ' + props.shows.length);

  return (
    <div>
      <Helmet defer={false}>
        <title>{landingTitle}</title>
        <meta
          name="description"
          content="Einzigartiges Kinoerlebnis. Sieger Preis / Leistung Kinotest 2022. Hier geht´s zum Kinoprogramm im Autokino Wien."
        />
        <meta
          name="keywords"
          content="Kinoprogramm Wien, Kino Wien, Kino, Autokino, Bestes Kino, Flohmarkt, Flohmarkt Wien, Eventlocation, Eventlocation Wien, Kinoticket kaufen, Kino Wien Programm, Jetzt im Kino Wien, Kino Samstag, Samstag im Kino, Kinofilme Samstag, Kino in der Nähe, Heute im Kino"
        />

        <link rel="canonical" href="https://autokino.at/kinoprogramm-wien/" />
      </Helmet>
      <ResponsiveWrapper>
        <Row className={Kinostyles.Flex}>
          <Col xs={12} lg={12}>
            <h1 className={Kinostyles.BanthinkHeadlineYellow}>
              Kinoprogramm
            </h1>
            <div className={Kinostyles.TextContainer + ' pl-3 pr-3'}>
              Lust auf ein einzigartiges Kinoerlebnis?
            </div>
            <Row className='p-4'>
              <Image
                src={image1}
                fluid
                alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
              />
            </Row>
            <div className={Kinostyles.divFlex}>
              <div className={Kinostyles.divCenterHalf}>
              <Image
                  src={iconSieger}
                  width={80}
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                />
                <div className={Kinostyles.TextContainerSmall}>
                Österreichs beliebtestes Kino 2023
                </div>
              </div>
              <div className={Kinostyles.divCenterHalf}>
              <Image
                  src={iconPrivat}
                  width={80}
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                  className={Kinostyles.IconImage}
                />
                <div className={Kinostyles.TextContainerSmall}>
                Privatssphäre im eigenen Auto
                </div>
              </div>
            </div>
            <div className={Kinostyles.divFlex}>
              <div className={Kinostyles.divCenterHalf}>
              <Image
                  src={iconVierbeiner}
                  width={80}
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                  class />
                <div className={Kinostyles.TextContainerSmall}>
                Nimm deinen Vier-beiner einfach mit
                </div>
              </div>
              <div className={Kinostyles.divCenterHalf}>
              <Image
                  src={iconSnacks}
                  width={80}
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                  className={Kinostyles.IconImage}
                />
                <div className={Kinostyles.TextContainerSmall}>
                Snacks direkt ins Auto geliefert
                </div>
              </div>
            </div>
            
            <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
              Du warst schon mal bei uns?
            </div>
            <div className={Kinostyles.TextContainer + ' pl-4 pr-4 pt-1'}>
              Schön dich wiederzusehen! Da du schon Auto-kinoprofi bist, schaue doch gleich weiter zu unserem Kinoprogramm.
            </div>
            <br />
            <div className={Kinostyles.CenterContent}>
              <button className={Kinostyles.CTAButton} onClick={(e) => scrollTo('kinoprogramm')}>  
                  Zum Kinoprogramm
              </button>
            </div>
          </Col>
        </Row>
        <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
          Du warst noch nie bei uns?
        </div>
        <div className={Kinostyles.TextContainer + ' pl-4 pr-4 pt-1'}>
          Wie aufregend! Aber keine Sorge, Autokino funktioniert einfacher als du denkst:
        </div>
        <br />
        <Row className={Kinostyles.TextContainer + ' pl-4 pr-4 pt-1'}>
          <Col xs={2}>
              <img src={imageZeitleiste} alt="Auto" style={{ width: "30px"}} />
          </Col>
          <Col xs={10}>
            <div className={Kinostyles.TextPurple}>
              Wähle deine Begleitung 👥
            </div>
            <div className={Kinostyles.TextContainer}>
              Egal ob Date, Familienausflug, Girls Night oder ein Kinoabend mit deinem Hund, ein Besuch im Autokino eignet sich für jeden Anlass!
            </div>
            <div className={Kinostyles.TextPurple + ' '+ Kinostyles.MarginTopDesktop}>
              Wähle dein Fahrzeug 🚗 🚲 🏍️🚶‍♀️
            </div>
            <div className={Kinostyles.TextContainer}>
              Ins Autokino kannst du sowohl klassisch mit dem Auto als auch alternativ mit dem Fahrrad, Motorrad oder zu Fuß kommen!
            </div>
            <div className={Kinostyles.TextPurple+ ' '+ Kinostyles.MarginTopDesktop}>
              Wähle deinen Film und sichere dir deine Tickets 🎥 🎟️
            </div>
            <div className={Kinostyles.TextContainer}>
             Als letzten Schritt wählst du deinen perfekten Film aus und sicherst dir die passenden Tickets.
            </div>
            <div className={Kinostyles.TextPurple+ ' '+ Kinostyles.MarginTopDesktop}>
            Zurücklehnen & Entspannen 🧘🏽
            </div>
            <div className={Kinostyles.TextContainer}>
             Voilà, du hast dein ideales Kino-Setup zusammengestellt. Den Rest übernehmen jetzt wird – lasse dich einfach von uns verwöhnen!
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={12}>
            <div className={Kinostyles.PSBox}>
            <font className={Kinostyles.TextPurple}>PS: </font> 
            Bei uns gibt es auch ein <b>riesiges Snack-angebot.</b> Auf dich warten sowohl <b>klassische Kinosnacks</b> als auch <b>Cocktails vom Profi, leckere Hotdogs (auch vegan)</b> sowie frisch gepresster <b>Fruchtsaft!</b> Zum <b>Selbstabholen</b> oder auch jederzeit (ohne Aufpreis) zu dir <b>ins Auto geliefert!</b>
            </div>
          </Col>
        </Row>
        <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
          Was unsere BesucherInnen sagen:
        </div>
        <div className={Kinostyles.TextPurpleSmall + ' mt-2'}>
        Weil wir guten Service lieben 🩷
        </div>
        <div className={Kinostyles.RezBox}> 
          <div className={Kinostyles.RezBoxName}>
            Katharina Stark
          </div>
          <Row>
            <Col xs={5}> <Image
                  src={imageSterne}
                  width={110}
                  alt="junges_paerchen_wartet_auf_kinoprogramm_start_wien"
                  title="glueckliche_kinobesucher_warten_auf_kinoprogramm"
                /></Col>
            <Col xs={7} className={Kinostyles.RezBoxGraySmall}>Vor 6 Monaten</Col>
          </Row>
          <div className={Kinostyles.RezBoxText}>
            Wir fahren mehrmals in der Saison ins Autokino, Gute Musik (vor dem Film), angenehme Atmosphäre. Gastro voll in Ordnung, so gute Popcorn bekommt man selten, Cocktails 1A. Einfach super, da Lautstärke selbst angepasst werden kann und die Hunde mässen nicht alleine daheim bleiben. Wenn es frisch wird, einfach Decke mitnehmen, dann ist es schön kuschelig
          </div>
        </div>
        <div className={Kinostyles.BoxLightPurple}>
            <font className={Kinostyles.TextPurple}>⏳Tipp: </font> 
            Viele unserer Vorstellungen sind ausverkauft. Buche deine Tickets also frühzeitig.
            </div>
      </ResponsiveWrapper>
      <div id="kinoprogramm">
      <ShowList
        shows={props.shows}
        saveMovieReminderSubscription={props.saveMovieReminderSubscription}
      />
      </div>
      <ResponsiveWrapper>
        <Row className={Kinostyles.Flex}>
          <Col xs={12} lg={12}>
            <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
            Keinen passenden Film gefunden?
            </div>
            <div className={Kinostyles.TextContainer + ' mt-1 ml-4'}>
              Keine Sorge, wir erweitern unser Programm regelmäßig. Bleib stets informiert, indem du unseren kostenlosen wöchentlichen Kino-programm Newsletter abonnierst, damit du keinen Film verpasst.
              <br />
              <br />
              
            </div>
            <div className={Kinostyles.CenterContent}>
            <FilmprogrammSignup />
            </div>
            <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
            Du möchtest das Kinoprogramm mitgestalten?
            </div>
            <div className={Kinostyles.TextContainer + ' mt-1 ml-4'}>
              Merke dich für Filme, Genres und Sprachen vor & lasse uns auf diese Weise wissen, was wir spielen sollen! Wir informieren dich gratis, sobald wir deinen Wunschfilm/-Genre/-Sprache spielen. #EuerKino
              <br />
              <br />
              
            </div>
            <div className={Kinostyles.CenterContent}>
            <button className={Kinostyles.CTAButton}>
                <a
                  href={ROUTES.UPCOMING_MOVIES}
                  className={Kinostyles.CTAButtonLink}
                >
                  Jetzt vormerken
                </a>
              </button>
            </div>
            <div className={Kinostyles.TextHeadlineBig + ' mt-2'}>
            Du möchtest gemeinsame Zeit verschenken?
            </div>
            <div className={Kinostyles.TextContainer + ' mt-1 ml-4'}>
              Überrasche deine Liebsten mit einem Autokino Gutschein und somit einer unvergesslichen Zeit hier im Autokino. Weil gemeinsame Zeit wertvoll ist.
              <br />
              <br />
              
            </div>
            <div className={Kinostyles.CenterContent}>
            <button className={Kinostyles.CTAButton}>
              <a href={ROUTES.GIFTCARD} className={Kinostyles.CTAButtonLink}>
                Gutscheine online kaufen
              </a>
            </button>
            </div>
            <br /> 
            <br />
          </Col>
        </Row>
      </ResponsiveWrapper>
    </div>
  );
};

LandingPage.propTypes = {
  fetchShows: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    shows: state.shows.shows,
  };
};

export default connect(
  mapStateToProps,
  { fetchShows, saveMovieReminderSubscription }
)(LandingPage);
